import { queryClient } from "index";
import MFAOptions from "./MFAOptions";
import Swal from "sweetalert2";
export const enableAndValidatingMFA = ({
  MFAType,
  qrCode,
  qrCodeURI,
  setSelectedValue,
  validateMFAEmailCode,
  verifyCodeInputClass,
  disableMFA,
  sendMFAEmailCode,
  enableMFAEmail,
  confirmCode,
}) => {
  let title = "";
  let bodyHTML = "";
  let confirmButtonText = "Yes";
  switch (MFAType) {
    case MFAOptions.Disabled.value:
      title = "Are you sure you want to disable 2FA?";
      break;
    case MFAOptions.Email.value:
      title = "Are you sure you want to enable 2FA with your Email?";
      break;
    case MFAOptions.AUTHENTICATOR_APP.value:
      const uri = qrCodeURI.replaceAll("%3D", "");
      const code = qrCode.replaceAll("=", "");
      const url =
        "https://chart.googleapis.com./chart?chs=200x200&cht=qr&chl=" + uri;
      title += "Set up Authenticator";
      bodyHTML = `
				<div style="height: 50vh; overflow-y: scroll;">
					1. <b>Get an Authenticator App</b> from the Play Store or App Store <br><hr>
					2. In the App, select <b>Set up account</b>. <br><hr>
					3. Choose <b>Scan a barcode</b> or enter secret code:<h6 id='qbenchShowHideSecretCode' data-value='hide' style='color:royalblue;cursor: pointer;'>Show secret code</h6><h6 id='qbenchSecretcode' style='display:none;'>"${code}"</h6>
					<div style="text-align: center; width: 100%;">
						<img style="max-height: 200px;
                        max-width: 200px;
                        margin:0 auto;
                        display: block;" src='${url}'><hr>
					</div>
					4. Type two consecutive MFA codes below <br>
					<label>MFA code 1</label>&nbsp;<input class='qbenchVerifyCode numberOnly' type='text' maxlength='6' style='width: inherit; display: inline-block;'/> <br>
					<label style="margin-top:10px;">MFA code 2</label>&nbsp;<input class='qbenchVerifyCode numberOnly' type='text' maxlength='6' style='width: inherit; display: inline-block;'/><hr>
				</div>
			`;
      confirmButtonText = "Verify";
      break;
    default:
      return;
  }
  Swal.fire({
    title: title,
    html: bodyHTML,
    showCancelButton: true,
    cancelButtonText: "No",
    confirmButtonText: confirmButtonText,
    allowEscapeKey: false,
    didOpen: () => {
      const showHideButton = document.getElementById(
        "qbenchShowHideSecretCode"
      );
      const secretCodeElement = document.getElementById("qbenchSecretcode");
      if (showHideButton) {
        showHideButton.addEventListener("click", function () {
          const currentDisplay = secretCodeElement.style.display;

          if (currentDisplay === "none") {
            secretCodeElement.style.display = ""; // To make it visible
            showHideButton.setAttribute("data-value", "hide");
            showHideButton.textContent = "Hide secret code";
          } else {
            secretCodeElement.style.display = "none"; // To hide it
            showHideButton.setAttribute("data-value", "show");
            showHideButton.textContent = "Show secret code";
          }
        });
      }
    },
    preConfirm: async () => {
      if (MFAType === MFAOptions.AUTHENTICATOR_APP.value) {
        const codeList = [
          ...document.querySelectorAll(`.${verifyCodeInputClass}`),
        ].map((input) => parseInt(input.value));
        try {
          const data = await confirmCode({ code_list: codeList });
          if (data?.message === "fail") {
            Swal.showValidationMessage("The code is incorrect");
          }
        } catch (e) {
          Swal.showValidationMessage("The code is incorrect");
        }
      }
    },
  }).then(async (result) => {
    if (result.isConfirmed) {
      if (MFAType === MFAOptions.Disabled.value) {
        await disableMFA();
        await queryClient.invalidateQueries("me");
        setSelectedValue(MFAType);
        Swal.fire("Your MFA has been disabled!", "", "success");
      } else if (MFAType === MFAOptions.Email.value) {
        const { user_2fa_id } = await sendMFAEmailCode();
        Swal.fire({
          title:
            "Please enter the 6-digit code that has been sent to your email",
          input: "text",
          inputAttributes: {
            autocapitalize: "off",
          },
          showCancelButton: false,
          confirmButtonText: "Confirm",
          showLoaderOnConfirm: true,
          allowOutsideClick: false,
          preConfirm: (code) => {
            return validateMFAEmailCode({
              code: code,
              user_2fa_id: user_2fa_id,
            })
              .then(({ message }) => {
                if (message === "fail") {
                  throw new Error("The code is incorrect!");
                }
                return message;
              })
              .catch((error) => {
                Swal.showValidationMessage(error);
              });
          },
        }).then(async (result) => {
          if (result.isConfirmed) {
            await enableMFAEmail();
            setSelectedValue(MFAType);
            Swal.fire("Your Email MFA has been successfully enabled!", "", "success");
          }
        });
      } else if (MFAType === MFAOptions.AUTHENTICATOR_APP.value) {
        setSelectedValue(MFAType);
        Swal.fire("Your Authenticator App MFA has been enabled!", "", "success");
      }
    }
  });
};

export const loginValidateEmailMFA = (validateMFAEmailCode, user_2fa_id) => {
  return Swal.fire({
    title: "Please enter the 6-digit code that has been sent to your email.",
    allowEscapeKey: false,
    input: "text",
    inputAttributes: {
      autocapitalize: "off",
    },
    showCancelButton: false,
    confirmButtonText: "Confirm",
    showLoaderOnConfirm: true,
    allowOutsideClick: false,
    preConfirm: (code) => {
      return validateMFAEmailCode({
        code: code,
        user_2fa_id: user_2fa_id,
      })
        .then(({ message }) => {
          if (message === "fail") {
            throw new Error("The code is incorrect!");
          }
          return message;
        })
        .catch((error) => {
          Swal.showValidationMessage(error);
        });
    },
  });
};

export const loginValidateAuthenticatorAppMFA = (
  validateMFAAuthenticatorCode,
  email,
  unlinkMFA
) => {
  return Swal.fire({
    title: "Enter your <br> 2-step Verification Code",
    html: `
        <div style="height: 10vh; overflow-y: scroll;">
            A 6-digit code is generated by your Authentication App <br>
            <div style='margin-top:10px;margin-bottom:-41px;cursor: pointer;'><a style="font-size:.8em;color:blue;" id='qbenchMFATrouble'><u>Having trouble with your MFA device? Click Here</u></a></div>
        </div>
      `,
    allowEscapeKey: false,
    input: "text",
    inputAttributes: {
      autocapitalize: "off",
    },
    showCancelButton: false,
    confirmButtonText: "Confirm",
    showLoaderOnConfirm: true,
    allowOutsideClick: false,
    didOpen: () => {
      const qbenchMFATrouble = document.getElementById("qbenchMFATrouble");

      if (qbenchMFATrouble) {
        qbenchMFATrouble.addEventListener("click", function () {
          Swal.fire({
            title: "",
            html: `<table class="table">
				<tr>
					<td style="border:none;">If you are having trouble using your MFA device, click the button below to receive an email to unlink your device.</td>
				</tr>
				<tr>
					<td style="border:none;"><a class='btn btn-primary btn-lg' id="unlinkMFA"> Unlink MFA Device </a></td>
				</tr>
				<tr>
					<td style="border:none;"><button id="closeSwal" style="margin-top:2px;" class="btn btn-secondary btn-sm">Cancel</button></td>
				</tr>
			</table>`,
            showConfirmButton: false,
            showCancelButton: false,
            didOpen: () => {
              const unlinkMFABtn = document.getElementById("unlinkMFA");
              const closeSwal = document.getElementById("closeSwal");

              if (closeSwal) {
                closeSwal.addEventListener("click", function () {
                  Swal.close();
                });
              }
              if (unlinkMFABtn) {
                unlinkMFABtn.addEventListener("click", function () {
                  unlinkMFA.disabled = true;
                  unlinkMFA(email).then(() =>
                    Swal.fire(
                      "You will receive an email shortly with a confirmation."
                    )
                  );
                });
              }
            },
          });
        });
      }
    },
    preConfirm: (code) => {
      return validateMFAAuthenticatorCode({
        code: code,
        email: email,
      })
        .then(({ message }) => {
          if (message === "fail") {
            throw new Error("The code is incorrect!");
          }
          return message;
        })
        .catch((error) => {
          Swal.showValidationMessage(error);
        });
    },
  });
};
